import { combineReducers } from 'redux';

import { generateAnswerSlice } from './answerGeneration';
import { attachesSlice } from './attaches';
import { biEngagementSlice } from './biEngagement';
import { chatSlice } from './chat';
import { errorsSlice } from './errors';
import { fieldSlice } from './field';
import { headerSlice } from './header';
import { helpCenterSlice } from './helpCenter';
import { homepageSlice } from './homepage';
import { lastClickedLinkSlice } from './lastClickedLink';
import { metaReducer } from './meta';
import { solutionsSlice } from './solutions';
import { supportRequestSlice } from './supportRequest';
import { TActions } from './types';
import { userSlice } from './user';
import { widgetSlice } from './widget';
import { widgetSessionSlice } from './widgetSession';

const combinedReducers = combineReducers({
  chat: chatSlice.reducer,
  field: fieldSlice.reducer,
  header: headerSlice.reducer,
  user: userSlice.reducer,
  attaches: attachesSlice.reducer,
  errors: errorsSlice.reducer,
  meta: metaReducer,
  widgetSession: widgetSessionSlice.reducer,
  widget: widgetSlice.reducer,
  helpCenter: helpCenterSlice.reducer,
  solutions: solutionsSlice.reducer,
  homepage: homepageSlice.reducer,
  biEngagement: biEngagementSlice.reducer,
  answerGeneration: generateAnswerSlice.reducer,
  lastClickedLink: lastClickedLinkSlice.reducer,
  supportRequest: supportRequestSlice.reducer,
});

export type TRootState = ReturnType<typeof combinedReducers>;

export const rootReducer = (state: TRootState, action: TActions) => {
  return combinedReducers(state, action);
};
